    
<div class="fulll d-flex flex-column justify-content-center align-items-center w-100" 
style="height: 100vh; overflow: hidden; background-image: url('../../../../assets/cal2.png'); background-repeat: repeat; background-size: cover; background-blend-mode: darken; filter: brightness(90%); background-color: rgb(87, 97, 117); background-position: center;">
<div id="watermark"></div> 
<div class="mainlogin d-flex flex-column align-items-center w-100" style="max-height: 80vh; overflow: hidden;">
   <div class="mainrow row w-100 justify-content-center">
       
       <div class="col-lg-5 col-md-8 col-12 d-flex flex-column bg-white p-4" style="align-items: center;">
           <div class="w-100">
               <div class="d-flex flex-row align-items-center">
                   <div class="makelogo1"></div>
                   <label class="mt-3 mx-2" style="font-size: large; font-weight: bold; color: #003366;">Appointele</label>
               </div>
              
           </div>
<!-- Pulsing Dots Spinner Overlay -->
<div *ngIf="loading" class="spinner-overlay">
    <div class="dots-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>
           <form class="w-100 pt-5" style="align-items: center;" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
               <h3>Login</h3>
               <p>Please enter your credentials</p>
               
               <div class="form-group mt-4">
                   <label for="username" style="font-weight: bold;">Enter your email address</label>
                   <input type="text" placeholder="Email Address" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
                   <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                       <div *ngIf="f.username.errors.required">Username is required</div>
                   </div>
               </div>

               <div class="form-group mt-4">
                   <label for="password" style="font-weight: bold;">Enter your password</label>
                   <input type="password" placeholder="Password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                   <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                       <div *ngIf="f.password.errors.required">Password is required</div>
                   </div>
               </div>

               <div class="form-group mt-4 w-100">
                   <button [disabled]="loading" class="btn btn-primary w-100">Login</button>
           
               </div>
               <div *ngIf="error" class="alert alert-danger">{{error}}</div>
           </form>
       </div>

       <div class="col-lg-7 d-none d-lg-flex flex-column pt-5" 
            style="align-items: center; background-color: rgb(100, 166, 223); ">
           <div class="w-100 text-center">
               <label class="text-center w-100 " style="font-size: x-large; color: #003366; font-weight: bold;">Efficiency Starts with Smart Scheduling</label>
               <img class="mx-4" style=" width: 80%; "  src="../../../../assets/login_cal.jpg"  alt="logo" >
           </div>
       </div>
   </div>
</div>
</div>

<!--<div class="full p-0 pt-1   justify-content-between w-100" style="height: 1920px; overflow: hidden;background-position: 0 -200px; padding-bottom: 100px;" >
    <div id="watermark" > </div>
    <div class="col-md-12 d-flex flex-column" style="align-items: center;">
    <div class="w-100 pt-5 text-center" > 
    <img class="mx-4" style="height: 10%; width: 10%; "  src="./assets/logo-ciot.png"  alt="logo" >
</div>


    <form class=" w-50  ml-0 pt-3 px-5" style=" height: 475px; align-items: center;  margin-block-end: auto;" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        
        
        <div class="form-group  ">
            <label class="rounded p-2 text-white" style="text-align: start; background-color:rgb(0, 77, 141) ;  font-weight: bolder" for="username" translate>Username</label>
            <input type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
            <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                <div *ngIf="f.username.errors.required">Username is required</div>
            </div>
        </div>
    
        <div class="form-group">
            <label class="rounded p-2 text-white" style="text-align: start; background-color:rgb(0, 77, 141) ; font-weight: bolder;" for="password" translate>Password</label>
        <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
            <div *ngIf="f.password.errors.required">Password is required</div>
        </div>
    </div>
       
        <div class="form-group mt-3">
            <button [disabled]="loading" class="btn text-white border border-white" translate >Login</button>
            <img *ngIf="loading" class="pl-2" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
        </div>
        <div *ngIf="error" class="alert alert-danger">{{error}}</div>
        
       
    </form>

    <div class="w-100 d-flex justify-content-end " >
    <div class="makelogo float-right">  </div> 
    <div class="d-flex flex-column float-right text-white m-4">
        <h6>Powered by</h6>
        <h4 class="" style="font-weight: bolder; font-family: DinPro;">JTCIPHER INC</h4>
        <div class="pt-1" style="background-color:rgb(15, 141, 244);"></div>
        <h5 class="" style="font-weight: bolder; font-family: DinPro;">SYHAT TECHNOLOGIES</h5>
        <div class="pt-1" style="background-color:rgb(15, 141, 244);"></div>
</div>
</div>
</div>
    </div>-->
   


<!--

<div class="full p-0 pt-1   justify-content-between " style="height: 1800px;" >
    <div style="margin: auto; width: 150px; height: 150px;"> <div class="makelogo "></div></div>
    <br>
</div>
<form class=" w-50  border p-5 " style="background:white; height: 1500px; align-items: center; margin: 0 auto;" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <h2 class="" >Login</h2>
    <div class="form-group">
        <label class="" for="username">Username</label>
        <input type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
        <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
            <div *ngIf="f.username.errors.required">Username is required</div>
        </div>
    </div>
    <div class="form-group">
        <label class="" for="password">Password</label>
        <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
            <div *ngIf="f.password.errors.required">Password is required</div>
        </div>
    </div>
    <div class="form-group">
        <button [disabled]="loading" class="btn bg-black text-white border border-white" style="background: black;">Login</button>
        <img *ngIf="loading" class="pl-2" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
    </div>
    <div *ngIf="error" class="alert alert-danger">{{error}}</div>
</form>
</div>-->